var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scoped-headhunterDetail"
  }, [_c('div', {
    staticClass: "white-block"
  }, [_c('p', [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'supplier'
        })
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-my-zuo ml-5"
  }), _vm._v(" 返回供应商列表")])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "banner-text mt-10"
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('p', {
    staticClass: "line-text-1"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "22px"
    }
  }, [_vm._v(_vm._s(_vm.supplier.linkman))]), _vm._v("（" + _vm._s(_vm.getSourceName(_vm.supplier.companyAbbr)) + "）")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('p-icon', {
    staticClass: "line-text-1",
    attrs: {
      "icon-name": "phone"
    }
  }, [_vm._v(_vm._s(_vm.supplier.tel))]), _vm._v(" "), _c('p-icon', {
    staticClass: "line-text-2",
    attrs: {
      "icon-name": "email"
    }
  }, [_vm._v(_vm._s(_vm.supplier.email))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('p-icon', {
    staticClass: "line-text-1",
    attrs: {
      "icon-name": "list"
    }
  }, [_vm._v(_vm._s(_vm.supplier.companyFullName))]), _vm._v(" "), _c('p-icon', {
    staticClass: "line-text-2",
    attrs: {
      "icon-name": "clock"
    }
  }, [_vm._v(_vm._s(_vm.supplier.createTime))])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "supplier-bottom"
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('label', [_vm._v("跟进HR：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.supplier.applicant))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('label', [_vm._v("签约部门：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.supplier.projectName))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('label', [_vm._v("备注：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.supplier.remark))])])], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "filter-result-header clearfix mt-20 mt-20"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "font-size": "18px",
      "color": "#333"
    }
  }, [_vm._v("子账号列表（" + _vm._s(_vm.dynamicForm.tableData.length) + "）")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.addRow
    }
  }, [_vm._v("添加账号")])], 1), _vm._v(" "), _c('el-form', {
    ref: "ruleTableForm",
    staticClass: "demo-ruleForm mt-20",
    attrs: {
      "model": _vm.dynamicForm
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dynamicForm.tableData,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "对接人",
      "align": "center",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.isEditStatus) ? _c('span', {
          domProps: {
            "textContent": _vm._s(scope.row.name)
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.isEditStatus) ? _c('el-input', {
          attrs: {
            "placeholder": "请输入对接人",
            "maxlength": 50
          },
          model: {
            value: (scope.row.name),
            callback: function($$v) {
              _vm.$set(scope.row, "name", $$v)
            },
            expression: "scope.row.name"
          }
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "对接人电话",
      "align": "center",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.isEditStatus) ? _c('span', {
          domProps: {
            "textContent": _vm._s(scope.row.phone)
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.isEditStatus) ? _c('el-form-item', {
          staticStyle: {
            "margin-top": "22px"
          },
          attrs: {
            "prop": 'tableData.' + scope.$index + '.phone',
            "rules": [{
                required: true,
                message: '请输入对接人电话',
                trigger: 'blur'
              },
              {
                pattern: /^[0-9]+$/,
                message: '请输入数字',
                trigger: 'blur,change'
              }
            ]
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入对接人电话",
            "maxlength": 20
          },
          model: {
            value: (scope.row.phone),
            callback: function($$v) {
              _vm.$set(scope.row, "phone", $$v)
            },
            expression: "scope.row.phone"
          }
        })], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "对接人邮箱"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.isEditStatus) ? _c('span', {
          domProps: {
            "textContent": _vm._s(scope.row.email)
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.isEditStatus) ? _c('el-form-item', {
          staticStyle: {
            "margin-top": "22px"
          },
          attrs: {
            "prop": 'tableData.' + scope.$index + '.email',
            "rules": [{
                required: true,
                message: '请输入对接人邮箱',
                trigger: 'blur'
              },
              {
                type: 'email',
                message: '请输入正确的邮箱地址',
                trigger: 'blur,change'
              }
            ]
          }
        }, [(scope.row.isEditStatus) ? _c('el-input', {
          attrs: {
            "placeholder": "请输入对接人邮箱",
            "maxlength": 50
          },
          model: {
            value: (scope.row.email),
            callback: function($$v) {
              _vm.$set(scope.row, "email", $$v)
            },
            expression: "scope.row.email"
          }
        }) : _vm._e()], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "所属地区"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.isEditStatus && scope.row.citys) ? _c('span', [_vm._v(_vm._s(_vm.getSelectMapText('WB_POSITION_CITY', scope.row.citys)))]) : _vm._e(), _vm._v(" "), (scope.row.isEditStatus) ? _c('el-form-item', {
          staticStyle: {
            "margin-top": "22px"
          },
          attrs: {
            "prop": 'tableData.' + scope.$index + '.citys',
            "rules": [{
              required: true,
              type: 'array',
              message: '请选择对接人所属地区',
              trigger: 'blur'
            }]
          }
        }, [_c('el-select', {
          attrs: {
            "multiple": ""
          },
          model: {
            value: (scope.row.citys),
            callback: function($$v) {
              _vm.$set(scope.row, "citys", $$v)
            },
            expression: "scope.row.citys"
          }
        }, _vm._l((_vm.selectMap.WB_POSITION_CITY), function(item, idx) {
          return _c('el-option', {
            key: idx,
            attrs: {
              "label": item.text,
              "value": item.value
            }
          })
        }), 1)], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "最近操作人/时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          domProps: {
            "textContent": _vm._s((scope.row.lastOperateName || '') + ' ' + (scope.row.modifyTime || ''))
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "align": "center",
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.isEditStatus) ? _c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-my-bianji color-info"
          },
          on: {
            "click": function($event) {
              return _vm.editRow(scope.$index, scope.row)
            }
          }
        }) : _vm._e(), _vm._v(" "), (!scope.row.isEditStatus) ? _c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-my-shanchu color-danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteRow(scope.$index, scope.row)
            }
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.isEditStatus) ? _c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-check color-success"
          },
          on: {
            "click": function($event) {
              return _vm.saveRow(scope.$index, scope.row)
            }
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.isEditStatus) ? _c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-my-guanbi color-danger"
          },
          on: {
            "click": function($event) {
              return _vm.cancelRow(scope.$index, scope.row)
            }
          }
        }) : _vm._e()]
      }
    }])
  })], 1)], 1)], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-157a797f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/supplier/supplierUsers.vue
// module id = null
// module chunks = 